import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import StudentDashboard from "../components/StudentDashboard";
import FeePayment from "../components/FeePayment";
import FeeHistory from "../components/FeeHistory";
import StudentProfile from "../components/StudentProfile";
import Receipt from "../components/Receipt";

function StudentPage({ user, token, onLogout }) {
  return (
    <div className="student-page">
      <Routes>
        <Route
          path="/"
          element={<StudentDashboard user={user} token={token} />}
        />
        <Route
          path="profile"
          element={<StudentProfile user={user} token={token} />}
        />
        <Route
          path="pay"
          element={<FeePayment user={user} token={token} />}
        />
        <Route
          path="history"
          element={<FeeHistory user={user} token={token} />}
        />
        <Route
          path="receipt/:paymentId"
          element={<Receipt user={user} token={token} />}
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default StudentPage;